export const DOMAIN_CREATED = "s0115";
export const DOMAIN_CREATE_ERROR = "e0115";
export const DOMAIN_UPDATED = "s0116";
export const DOMAIN_UPDATE_ERROR = "e0116";
export const DOMAIN_TURNED_ON = "s0117";
export const DOMAIN_TURN_ON_ERROR = "e0117";
export const DOMAIN_TURNED_OFF = "s0118";
export const DOMAIN_TURN_OFF_ERROR = "e0118";
export const DOMAIN_REMOVED = "s0119";
export const DOMAIN_REMOVE_ERROR = "e0119";

export const domain = {
    [DOMAIN_CREATED]: {
        colorClass: "color_domain",
        icon: "/img/domain.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.domain.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.domain.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.create"),
            entityType: $t("notification.contract.entity.domain"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [DOMAIN_UPDATED]: {
        colorClass: "color_domain",
        icon: "/img/domain.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.domain.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.domain.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.update"),
            entityType: $t("notification.contract.entity.domain"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [DOMAIN_REMOVED]: {
        colorClass: "color_domain",
        icon: "/img/domain.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.domain.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.domain.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.delete"),
            entityType: $t("notification.contract.entity.domain"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [DOMAIN_TURNED_ON]: {
        colorClass: "color_domain",
        icon: "/img/domain.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.domain.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.domain.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOn"),
            entityType: $t("notification.contract.entity.domain"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [DOMAIN_TURNED_OFF]: {
        colorClass: "color_domain",
        icon: "/img/domain.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.domain.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.domain.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOff"),
            entityType: $t("notification.contract.entity.domain"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [DOMAIN_CREATE_ERROR]: {
        isError: true,
        colorClass: "color_domain",
        icon: "/img/domain.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.domain.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.domain.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.create"),
            entityType: $t("notification.contract.entity.domain"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.domain")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    }
}; 